export default __webpack_public_path__ + "static/media/home.ef84a343.png";